import { RouterProvider } from "react-router-dom";
import { EuiProgress } from "@elastic/eui";
import { useConfig } from "./hooks/useConfig";
import { AppInsightsContext, reactPlugin } from "./AppInsights";
import { router } from "routes/router";

const App = () => {
  const [isLoading] = useConfig();

  if (isLoading) return <EuiProgress size="xs" color="primary" position="fixed" />;

  return (
    <AppInsightsContext.Provider value={reactPlugin}>
      <RouterProvider router={router} />
    </AppInsightsContext.Provider>
  );
};

export default App;
